import { Color } from 'three'

import { deepMerge, getTargetOffset, getTargetOffsetTop, replaceColorCode, setElementHide } from 'js/utils/Utils'
import { clamp, lerp } from 'js/utils/Maths'

import BasePlaneMesh from 'js/webgl/customMeshes/base/BasePlaneMesh'
import Common from 'js/_core/Common'

import VertexShader from 'js/webgl/_glsl/vert/planeMesh.vert'
import FragmentShader from 'js/webgl/_glsl/frag/bgColorPlaneMesh.frag'

const defaults = {
  instanceName: 'bgColorPlaneMesh',
  effectInfo: {
    color: '#f1f1f1',
  },
}

export default class BgColorPlaneMesh extends BasePlaneMesh {
  wh = 0

  constructor(options = {}) {
    super({
      vs: VertexShader,
      fs: FragmentShader,
    })

    this.webgl = null
    this.uniforms = this.uniforms || {}
    this.isInView = false
    this.inViewAnimated = false
    this.width = 0
    this.height = 0

    this.originPos = {
      x: 0,
      y: 0,
    }

    this.meshOffset = {
      x: 0,
      y: 0,
    }
    this.meshProps = {}

    deepMerge(this, defaults, options)
  }

  init() {
    this._set$()
    super.init()
    this._setUniforms()
    this._setBaseSize()
    this.setResolutions()

    if (this.$target) {
      {
        this.$target.style.backgroundColor = 'transparent'
      }
    }

    Common.webgl.stage.scene.add(this.mesh)
  }

  destroy() {
    super.destroy()
  }

  _set$() {
    if (this.$target) {
    }
  }

  _setUniforms() {
    const data = this.$target ? this.$target.dataset : {}
    if (data && data.bgSection) {
      switch (data.bgSection) {
        case 'black': {
          this.effectInfo.color = '#0d0d0d'
        }
      }
    }

    deepMerge(this.uniforms, {
      uMeshOffset: {
        value: {
          x: 0,
          y: 0,
        },
      },
      uColor: {
        value: new Color(this.effectInfo.color).convertLinearToSRGB(),
      },
    })
  }

  setTexture() {}

  setResolutions() {
    if (this.$target) {
      const rect = this.$target.getBoundingClientRect()
      this.width = rect.width
      this.height = rect.height

      this.uniforms.uMeshResolution.value.x = this.width
      this.uniforms.uMeshResolution.value.y = this.height

      this.originPos.x = -(Common.webgl.stage.stageSize.width * 0.5) + this.width * 0.5
      this.originPos.y = Common.webgl.stage.stageSize.height * 0.5 - this.height * 0.5

      // if (this.mesh) {
      //   this.mesh.position.z = 0.0001
      // }
    }
  }

  _setPosition() {
    const offset = getTargetOffset(this.$target)

    this.meshOffset.x = offset.left
    this.meshOffset.y = offset.top

    this.uniforms.uMeshOffset.value.x = this.originPos.x + this.meshOffset.x
    this.uniforms.uMeshOffset.value.y = this.originPos.y - (this.meshOffset.y - Common.scroll.currentScroll)
  }

  _setBaseSize() {
    super._setBaseSize()
    this.wh = window.innerHeight
  }

  onResize() {
    this._setBaseSize()
    this.setResolutions()
    this._setPosition()
  }

  onRaf() {
    this._setPosition()

    if (Common.iomEnable && this.isInView) {
    }
  }
}